import { breakpoints, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const FilterContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};

  ${breakpoints.sm} {
    flex-flow: row wrap;
    gap: ${theme.spacing.md};
  }

  &:empty {
    display: none;
  }
`;
export const ActionContainer = styled.div `
  display: flex;
  flex-flow: row wrap;
  gap: ${theme.spacing.md};
`;
